import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux/es/exports';
import {ReactComponent as AddPlus} from "../../icons/svg/TagsDDSelect/add-plus.svg"
import MainTagsList from "./MainTagsList";
import Loader from "../../Loader/Lodaer";
import { TagTypeModel, TagsAppProps } from "./types";
import { getTagsList } from "./actions/getTagsList";
import { RootState } from "../../store";
import { addTags } from "../../asyncActions/addTag";

export default function MTagsApp({taskId, matchRegExp='', modalShow, updateTagList, tagsInList, isHideCheckedItems=false, showCheckbox=true, removeTagFromTagList}: TagsAppProps)  {
    const dispatch = useDispatch();
    const [activeIndexTag, setActiveIndexTag] = useState(0);
    const escapedPattern = matchRegExp.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const arr = tagsInList?.map(tag => tag.tagId);
    const [tags, setTags] = useState<TagTypeModel[]>([])
    const refUlTags = useRef<HTMLUListElement>(null);
    const refAddBtn = useRef<HTMLButtonElement>(null);
    const refAddBtnIco = useRef<SVGSVGElement>(null)
    const activeIndexTagRef = useRef(activeIndexTag);
    const { loading, tagsList, error } = useSelector((state: RootState) => state.tagsNew) 
    
    useEffect(() => {
        activeIndexTagRef.current = activeIndexTag;
    }, [activeIndexTag]);

    useEffect(() => {
        setTags(() => tagsList.filter(el => new RegExp (escapedPattern, 'i').test(el.tagName)));
         // eslint-disable-next-line
    }, [matchRegExp, tagsList])

    const addTagFunction = (value: string) => {
        dispatch(addTags({tagName: value}))
        .then(() => {
            dispatch(getTagsList())
            setTags(tagsList)
        })
                
    }

    const handleMoveTags = (e: KeyboardEvent) => {
        if (tags.length > 0) {
            if (e.code === 'ArrowDown' || e.code === 'ArrowUp' || e.code === 'Enter') {
                e.preventDefault();
                if (e.code === 'ArrowDown') {
                    setActiveIndexTag(i => (i + 1) % tags.length);
                }
                if (e.code === 'ArrowUp') {
                    setActiveIndexTag(i => (i - 1 + tags.length) % tags.length);
                }
                if (e.code === 'Enter') {
                    updateTagList(e, {tagId: tags[activeIndexTagRef.current].id, tagName: tags[activeIndexTagRef.current].tagName})
                }
            }
        }
    }

    useEffect(() => {
        if (refUlTags.current) {
            const arrElem = refUlTags.current.querySelectorAll('.tags__item')
            arrElem[activeIndexTag].scrollIntoView({ block: "nearest"  });
        }
    }, [activeIndexTag, refUlTags])

    
    
    useEffect(() => {
        if (isHideCheckedItems) {
            if (tagsInList.length > 0) {
                setTags(prevState => prevState.filter(elX => !tagsInList.some(elY => elY.tagId === elX.id)))                
            }
        }
         // eslint-disable-next-line
    }, [tagsInList])
    
    useEffect(() => {
        if (tags.length === 0) {
            setTimeout(() => {
                if (refAddBtn.current && refAddBtnIco.current) {
                    refAddBtn.current.style.backgroundColor = '#5932EA';
                    refAddBtn.current.style.color = '#FFF';
                    refAddBtn.current.style.transition = 'all 0.2s ease-out';
                    refAddBtnIco.current.style.fill = '#FFF'
                    refAddBtnIco.current.style.transition = 'fill 0.2s ease-out';
                }
            }, 100);
        }   
    }, [tags])

    useEffect(() => {
        document.addEventListener('keydown', handleMoveTags)

        return () => {
            document.removeEventListener('keydown', handleMoveTags)
        }
    }, [tags]) // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) {
        return (
            <div style={{margin: 'auto'}}>
                <Loader />
            </div>
        )   
    } else if (error) {
        return (
            <div>
                <p>{error}</p>
            </div>
        )
    } else {
        return (
            <>
                {
                    tags.length ?
                    <ul className="tags__list ym-hide-content" id='matchedList' ref={refUlTags}>
                        {
                            tags.map((el: TagTypeModel, index) => {
                                return <MainTagsList modalShow={modalShow}
                                            showCheckbox={showCheckbox} 
                                            updateTagList={updateTagList} 
                                            keys={index}
                                            coloredPart={matchRegExp}
                                            isHideCheckedItems={isHideCheckedItems}
                                            isMarked={index === activeIndexTag ? true : false}
                                            taskId={taskId} 
                                            tags={el}
                                            inList={arr?.includes(el.id)}
                                            tagList={tagsInList}
                                            removeTagFromTagList={removeTagFromTagList}/>
                            })

                        }
                    </ul> : 
                    matchRegExp.length === 0 ?
                    tagsList.length === 0 && <p className="tags__data-nothing">У вас пока нет меток</p> :
                    <div className="notmatch-container">
                        <button ref={refAddBtn} type="button" className="addTagFromFinder" 
                            onClick={() => addTagFunction(matchRegExp)}>
                            <AddPlus ref={refAddBtnIco} className="addPlus"></AddPlus>
                            Создать метку
                        </button>
                    </div>
                }
            </>
        )
    }
}